<script setup>
// import { ref } from 'vue';
import BatchStockTable from "./Tables/BatchStockTable.vue";
// import SawitBuahScheduleTable from "./Tables/SawitBuahScheduleTable.vue";
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import ArgonRadio from "@/components/ArgonRadio.vue";

</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Batch Stock</h6>
                </div>
                <div class="container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Batch No#</label>
                            <!-- <select class="form-control" v-model="model.stock.id"> 
                                <optgroup v-for="(items, category) in groupedStockItems" :label="category" :key="category" > 
                                    <option v-for="(itemObj) in items" :key="itemObj.id" :value="itemObj.id" > 
                                        {{ itemObj.item }} - {{ itemObj.supplier }}
                                    </option> 
                                </optgroup> 
                            </select> -->
                            <select class="form-control" v-model="model.batchstock.batchno">
                                <optgroup
                                    v-for="(items, groupLabel) in groupedStockItems"
                                    :key="groupLabel"
                                    :label="groupLabel"
                                >
                                    <option
                                    v-for="item in items"
                                    :key="item.batchno"
                                    :value="item.batchno"
                                    >
                                    {{ item.batchno }}
                                    </option>
                                </optgroup>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Quantity (Pokok)</label>
                            <input class="form-control" v-model="model.batchstock.quantity" id="input_quantity" type="number" placeholder="1" />
                        </div>
                     
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Date</label>
                            <input type="date" id="input_dateto" class="form-control" v-model="model.batchstock.date">
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Status</label>
                            <div class="d-flex align-items-center">
                                <argon-radio id="inStock" name="stock-status" class="me-3" :checked="model.batchstock.status === 0" @click="model.batchstock.status = 0">In</argon-radio>
                                <argon-radio id="outStock" name="stock-status" class="me-3" :checked="model.batchstock.status === 1" @click="model.batchstock.status = 1">Out</argon-radio>
                                <argon-radio id="cuciStock" name="stock-status" :checked="model.batchstock.status === 2" @click="model.batchstock.status = 2">Cuci</argon-radio>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.batchstock.remark"  placeholder="Remark...." />
                        </div>
                        <div class="col-md-3" v-show="model.batchstock.status === 1">
                            <label for="example-text-input" class="form-control-label">Reference (Inv/ DO)</label>
                            <argon-input type="text" id="input_reference" v-model="model.batchstock.reference"  placeholder="Reference...." />
                        </div>
                        <div class="col-md-2" v-show="model.batchstock.status === 1">
                            <label for="example-text-input" class="form-control-label">Unit Price (RM)</label>
                            <argon-input type="number" id="input_price" v-model="model.batchstock.price"  placeholder="Price...." />
                        </div>
                        <div class="col-md-3" v-show="model.batchstock.status === 1">
                            <label for="example-text-input" class="form-control-label">Customer Name</label>
                            <argon-input type="text" id="input_customer" v-model="model.batchstock.customer"  placeholder="Customer/Company Name...." />
                        </div>
                    </div>
                    <div class="row">
                        <!-- <div class="col-md-10">
                            <button class="btn btn-info " @click="addStock" style="float: right;" id="btn_camera">Open Camera</button>
                        </div> -->
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addStock" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-4 row">
        <div class="col-md-12">
            <BatchStockTable :key="componentKey" />
        </div>
    </div>
    <!-- <div class="mt-4 row">
        <div class="col-md-6">
            <SawitBuahScheduleTable :key="sawitBuahScheduleKey" />
        </div>
    </div> -->
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'stockCreate',
  data(){
    return {
        // image:'',
        componentKey: 0,
        // sawitBuahScheduleKey: 0,
    //   errorList: '',
      model:{
        batchstock:{
            batchno:'',
            status:0,
            quantity:'',
            remark:'',
            reference:'',
            date: new Date().toISOString().slice(0,10),
            price:'0',
            customer:''
        },
        batchlist:[]
      },
      rawDate:'',
    }
  },
  computed: { 
    groupedStockItems() { 
        const groups = {};

        this.model.batchlist.forEach(item => {
        const groupKey = `${item.product} / ${item.clone}`;
        if (!groups[groupKey]) {
            groups[groupKey] = [];
        }
        groups[groupKey].push(item);
        });

        return groups;
    } 
  },
  mounted(){
    this.listAllBatch();
  },
  methods: {
    addStock(){
        const found = this.model.batchlist.find(obj => Object.values(obj)[0] === this.model.batchstock.batchno);
        this.model.batchstock.batchno = found.batchno;
        //var mythis = this;
        //console.log(JSON.stringify(this.model.stock));
        axios.post('nursery/addBatchStock',this.model.batchstock)
            .then(res => {
                alert(res.data.message);
                // this.uploadImage();
                this.model.batchstock = {
                    batchno: this.model.batchlist[0].batchno,
                    status:0,
                    quantity:'',
                    remark:'',
                    reference:'',
                    date: new Date().toISOString().slice(0,10),
                    price:'0'
                },
                this.componentKey += 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: batch no, quantity, date and status is required!');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    listAllBatch(){
        axios.get('nursery/listAllNurseryBatch/%/0/%')
            .then(res => {
                this.model.batchlist = res.data.batchlist;
                this.model.batchstock.batchno = res.data.batchlist[0].batchno;
                if(this.$route.params.id != ''){
                    this.model.batchstock.batchno = this.$route.params.id;
                    //console.log(this.$route.params.status,"status");
                }
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    }
    
  },
}
</script>